import axios, { AxiosError } from "axios";
import { ApiResult, ErrorResponseData, getDefaultHeaders, getAdminHeaders } from "../../common/api/Api";
import { DEFAULT_TIMEOUT, getAppEnv } from "../../common/settings";
import { User } from "./UserModel";
import { UserDto } from "./UserDto";
import { userMapper } from "./UserModelMapper";

const appEnv = getAppEnv();

/**
 * 実行者のユーザ情報を保存します。
 *
 * @returns 処理結果
 *    処理成功時は data プロパティに ユーザ {@link User} が格納されます。
 *    エラー発生時は error プロパティにエラー情報が格納されます。
 */
export const updateMe = async (): Promise<ApiResult<User, ErrorResponseData>> => {
  try {
    const response = await axios.get<UserDto>(`${appEnv.webApiEndPoint}/app/api/user/updateMe`, {
      headers: getDefaultHeaders(),
      timeout: DEFAULT_TIMEOUT,
    });

    const user = userMapper.map(response.data);
    return { data: user };
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    return { error: err };
  }
};

/**
 * 実行者のユーザ情報とテナント情報を保存します。
 *
 * @returns 処理結果
 *    処理成功時は data プロパティに ユーザ {@link User} が格納されます。
 *    エラー発生時は error プロパティにエラー情報が格納されます。
 */
export const updateMeWithTenant = async (): Promise<ApiResult<User, ErrorResponseData>> => {
  try {
    const response = await axios.get<UserDto>(`${appEnv.webApiEndPoint}/app/api/user/updateMeWithTenant`, {
      headers: getDefaultHeaders(),
      timeout: DEFAULT_TIMEOUT,
    });

    const user = userMapper.map(response.data);
    return { data: user };
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    return { error: err };
  }
};

/**
 * 実行者のユーザ情報をチェックします。
 *
 * @returns 処理結果
 *    処理成功時は data プロパティに ユーザ {@link User} が格納されます。
 *    エラー発生時は error プロパティにエラー情報が格納されます。
 */
export const adminCheckMe = async (): Promise<ApiResult<User, ErrorResponseData>> => {
  try {
    const response = await axios.get<UserDto>(`${appEnv.webApiEndPoint}/app/api/admin/checkMe`, {
      headers: getAdminHeaders(),
      timeout: DEFAULT_TIMEOUT,
    });

    const user = userMapper.map(response.data);
    return { data: user };
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    return { error: err };
  }
};
